module.exports = __webpack_public_path__ + "img/shop-banner.a02fbe9f.png";